<template>
  <div class="events">
    <!-- Device Selection -->
    <div class="bg-black p-1 rounded" style="height: 680px;">
        <div class="row">
            <div class="col-md-2">
                <p class="fs-1 fw-light text-white text-center mt-2 ms-1" style="letter-spacing: 5px;">Events</p>
            </div>
            <div class="col-md-6">
                <div class="input-group flex-nowrap">
                    <button class="btn btn-synapse-dark text-white fw-light fs-4 rounded mt-1 me-2 w-25"  style="height: 80px;" :disabled="gettingProbes" @click="getProbes">
                        <i class="fa-solid fa-xl fa-arrows-rotate" :class="{'fa-spin': gettingProbes}"></i>
                    </button>
                    <button class="btn text-white fw-light fs-4 rounded mt-1 me-2 w-25" :class="{'btn-synapse-dark': probesType=='urls', 'bg-synapse-glass': probesType!='urls'}" style="height: 80px;" title="Get URL probes." :disabled="gettingProbes" @click="clear('urls');">
                        <i class="fa-solid fa-xl fa-globe" :class="{'fa-beat': gettingProbes}"></i>
                    </button>
                    <button v-if="false" class="btn text-white fw-light fs-4 rounded mt-1 me-2 w-25" :class="{'btn-synapse-dark': probesType=='databanks', 'bg-synapse-glass': probesType!='databanks'}" style="height: 80px;" title="Get Databank probes." :disabled="gettingProbes" @click="clear('databanks');">
                        <i class="fa-solid fa-xl fa-database" :class="{'fa-beat': gettingProbes}"></i>
                    </button>
                    <button class="btn text-white fw-light fs-4 rounded mt-1 me-2 w-25" :class="{'btn-synapse-dark': probesType=='pings', 'bg-synapse-glass': probesType!='pings'}" style="height: 80px;" title="Get ping probes." :disabled="gettingProbes" @click="clear('pings');">
                        <i class="fa-solid fa-xl fa-rss" :class="{'fa-beat': gettingProbes}"></i>
                    </button>
                    <button class="btn text-white fw-light fs-4 rounded mt-1 me-2 w-25" :class="{'btn-synapse-dark': probesType=='traceroutes', 'bg-synapse-glass': probesType!='traceroutes'}" style="height: 80px;" title="Get traceroute probes." :disabled="gettingProbes" @click="clear('traceroutes');">
                        <i class="fa-solid fa-xl fa-road" :class="{'fa-beat': gettingProbes}"></i>
                    </button>
                    <select class="btn btn-synapse-dark fs-5 fw-light mt-1 rounded w-50" v-model="selected_probe" :disabled="gettingProbes || probesType == null" style="height: 80px;" @change="lightClear">
                        <option :value="null">Select a probe...</option>
                        <option v-for="(_, i) in probes[probesType]" v-bind:key="i+1" :value="_">{{String(_.alias) + ` (${_.category})`}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-2">
                <select class="btn btn-synapse-dark fs-5 fw-light mt-1 rounded w-100" v-model="period" :disabled="selected_probe==null" style="height: 80px;" @change="setProbe">
                    <option :value="null">Select period...</option>
                    <option value="day">Last Day</option>
                    <option value="week">Last Week</option>
                    <option value="2week">Last 2 Weeks</option>
                    <option value="month">Last Month</option>
                </select>
            </div>
            <div class="col-md-1">
                <button class="btn btn-synapse-dark fs-4 mt-1 w-100" style="height: 80px;" :disabled="period == null || selected_probe == null" @click="getEvents">
                    <i class="fa-solid fa-xl fa-magnifying-glass" :class="{'fa-beat': gettingEvents}"></i>
                </button>
            </div>
            <div class="col-md-1">
                <button class="btn btn-synapse-dark fs-4 mt-1 w-100" style="height: 80px;"  @click="clear(null)">
                    <i class="fa-solid fa-xl fa-broom"></i>
                </button>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12" align="center">
                <div class="w-100" v-show="eventsReady">
                    <Timeline timelineHeight="470" :events="events" ref="eventsTimelineSynapse"></Timeline>
                </div>
                <div v-show="!eventsReady">
                    <div class="bg-black p-2 rounded text-white fs-3" style="height: 580px;">
                        <div style="margin-top: 17%;">
                            <i class="fa-solid fa-xl fa-calendar-days" :class="{'fa-beat': gettingEvents}"></i>
                            <p class="text-white fw-light">{{eventsMessage}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// Import the vue components

/* 

<div class="col-md-6">
    <div class="bg-dark rounded p-1" style="height: 580px;">
        <p class="text-white fw-light ">Events Chart</p>
        <div class="bg-black p-1 rounded">
            <LineChart :chartData="eventsChartData"></LineChart>
        </div>
    </div>
</div>

*/


// Import the component with the line below.
import Timeline from '@/components/apps-components/synapse/subs/Timeline.vue'

import axios from "axios";

export default {
  name: 'Events',
  components: {
    Timeline
  },
  data(){
    return {
        // General.
        site: null,
        stage: null,

        // Probes
        gettingProbes: false,
        probes: { null: [] },
        probesType: null,
        selected_probe: null,
        
        // Events
        events: [],
        gettingEvents: false,
        eventsReady: false,
        eventsMessage: "Waiting for execution...",
        period: null
    }
  },
  methods:{
    // Probes
    getProbes(){
        this.clear(null)
        this.gettingProbes = true
        const params = {}
        const dest = this.site + '/synapse/events/getProbes' 
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.probes = rx.data.probes
                this.gettingProbes = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingProbes = false
        });
    },
    setProbe(){
        if (this.selected_probe == null){  this.clear(); return }
    },
    clear(probetype){
        this.selected_probe = null
        this.period = null
        this.probesType = probetype
        this.eventsMessage = "Waiting for execution..."
        this.eventsReady = false
        this.gettingEvents = false
    },
    lightClear(){
        this.eventsReady = false
        this.eventsMessage = "Waiting for execution..."
    },
    // Events
    getEvents(){
        this.gettingEvents = true
        this.eventsReady = false
        this.eventsMessage = "Retrieving events..."
        this.events = []
        this.$refs['eventsTimelineSynapse'].resetVisor()
        const params = {uid: this.selected_probe.uid, type: this.selected_probe.type, period: this.period}
        const dest = this.site + '/synapse/events/getEvents'
        axios
            .get(dest, {params})
            .then(rx => {
                this.events = rx.data.events
                this.gettingEvents = false
                this.eventsReady = true
                if (this.events.length == 0){
                    this.eventsReady = false
                    this.eventsMessage = "No events in the period..."
                }
            })
            .catch(error => {
                this.eventsMessage = this.processErrorMessage(error.response.data)
                this.gettingEvents = false
                this.eventsReady = false
            });
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = error.error
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
        return err_message
    },
    // Miscelaneous
    capitalize(_string){
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    getImage(base){
        return this.bases[base]
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  mounted: function(){
    this.getProbes()
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  }
}
</script>

<style scoped>
    /* BTN-Synapse */
    .btn-synapse{
        background-color: rgb(108, 194, 225);
        color: Black;
        box-shadow: 0px 0px 8px 0px rgb(249, 249, 249);
        transition-duration: 0.5s;
    }
    .btn-synapse:hover{
        box-shadow: 0px 0px 25px 0px rgb(249, 249, 249);
        color: White;
    }

    .btn-synapse-dark{
        background-color: rgb(0, 54, 73);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(0, 81, 125);
        transition-duration: 0.5s;
    }
    .btn-synapse-dark:hover{
        box-shadow: 0px 0px 25px 0px rgb(0, 81, 125);
        color: rgb(52, 143, 186);
    }

    .bg-synapse-glass{
        box-shadow: inset 0 0 2000px rgba(13, 80, 106, 0.447);
    }
    .bg-glass{
        box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.216);
    }
    .bg-light-glass{
        box-shadow: inset 0 0 1000px rgba(50, 248, 255, 0.108);
    }

    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

</style>
